<template>
    <div>
        <div v-for="(suggestion, index) in suggestions" :key="suggestion.id"
            class="suggestion-item is-hidden-touch" :class="{ 'is-active': index === selectedIndex }"
            @click="selectSuggestion(suggestion)" @mouseover="handleMouseOver(index)">
            {{ suggestion.nombre }}
        </div>
        <div v-if="totalSuggestions > 5" class="show-all-link-container is-hidden-touch">
            <a href="#" class="has-text-link is-underlined"
                @click.prevent="handleShowAllResults">
                Mostrar todos los resultados
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DesktopSuggestions',
    props: {
        suggestions: {
            type: Array,
            required: true
        },
        selectedIndex: {
            type: Number,
            required: true
        },
        totalSuggestions: {
            type: Number,
            required: true
        }
    },
    methods: {
        selectSuggestion(suggestion) {
            this.$emit('select', suggestion)
        },
        handleMouseOver(index) {
            this.$emit('mouseover', index)
        },
        handleShowAllResults() {
            this.$emit('show-all')
        }
    }
}
</script> 